/**
 * Centralized Application State Store
 * Replaces the global window.sessionConfig and window.sessionState to avoid coupling.
 */

export const store = {
    config: {
        problemType: null,
        level: null,
        context: null,
        currentStep: 1,
        mode: 'offline',
        contextExplicit: true
    },
    state: {
        problems: [],
        currentProblem: 0,
        answers: {},
        solvedProblemIds: []
    }
};

if (typeof window !== 'undefined') {
    window.Detectimaticas = window.Detectimaticas || {};
    window.Detectimaticas.store = store;
}
